import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MaterialMdcModule } from '../shared/material-mdc.module';
import { WrongDeviceRoutingModule } from './wrong-device-routing.module';
import { WrongDeviceComponent } from './wrong-device.component';



@NgModule({
  declarations: [WrongDeviceComponent],
  imports: [
    CommonModule,
    SharedModule,
    MaterialMdcModule,
    WrongDeviceRoutingModule
  ]
})
export class WrongDeviceModule { }
